export const WORKS = [
  {
    company: "Realtor.com",
    companyHref: "https://www.realtor.com",
    positions: [
      {
        name: "Associate Software Engineer",
        date: "September 2020 - Present",
      },
      {
        name: "Software Engineer Co-op",
        date: "September 2019 - April 2020",
      },
    ],
    techs: [
      "React",
      "JavaScript",
      "NextJs",
      "NodeJs",
      "React Testing Library",
      "Jest",
      "Google Maps API",
      "GraphQL",
      "SEO",
      "AWS",
    ],
  },
  {
    company: "Spexi",
    companyHref: "https://spexigeo.com/",
    positions: [
      {
        name: "Junior Software Developer",
        date: "May 2018 - Dec 2018",
      },
    ],
    techs: [
      "React",
      "React Native",
      "Javascript",
      "PHP",
      "Laravel",
      "SQL",
      "Java",
      "Objective-C",
      "Redux",
      "DJI",
      "RESTful API",
    ],
  },
];
